export const ADD_MESSAGE = Symbol('ADD_MESSAGE');
export const DISMISS_MESSAGE = Symbol('DISMISS_MESSAGE');

const MESSAGE_VARIANT_ERROR = 'error';
const MESSAGE_VARIANT_CONFIRMATION = 'confirmation';

export function raiseError(error) {
  console.error(error);
  return { type: ADD_MESSAGE, message: { variant: MESSAGE_VARIANT_ERROR, text: error.message } };
}

export function raiseConfirmation(message) {
  return { type: ADD_MESSAGE, message: { variant: MESSAGE_VARIANT_CONFIRMATION, text: message } };
}

export function dismissMessage() {
  return { type: DISMISS_MESSAGE };
}
